import { AddIcon, MinusIcon } from '@chakra-ui/icons';

type Props = {
    id: string;
    isExpanded: boolean;
};

export const ExpandIcon: React.FC<Props> = ({ id, isExpanded }: Props) =>
    isExpanded ? (
        <MinusIcon data-testid={`${id}-minus-icon`} width={2} height={2} />
    ) : (
        <AddIcon data-testid={`${id}-add-icon`} width={2} height={2} />
    );
